import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xzekcvz2yt: FaireBrandEntity = {
  token: "b_xzekcvz2yt",
  type: "brand",
  name: "Bon Femmes",
  avatarUrl:
    "https://cdn.faire.com/fastly/d20c1a4f864b6c6f011179a955e804120906bd0ae7f0f7bebc4caa6f14089ee1.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d81b50c3c52f9338d059bd36ea91d889ba0f220b1d36369766af2c5ce270f497.png",
  logoUrl:
    "https://cdn.faire.com/fastly/d20c1a4f864b6c6f011179a955e804120906bd0ae7f0f7bebc4caa6f14089ee1.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d81b50c3c52f9338d059bd36ea91d889ba0f220b1d36369766af2c5ce270f497.png",
  location: "Chicago, IL, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 26,
  isTopShop: true,
  isInsider: true,
  description:
    "Hi! My name is Omotola Akinbiyi and I am the founder of Bon Femmes, a lifestyle brand dedicated to woman makers and designers. With my growing love of all things art and design, I started developing my own collection of art prints, stationery and so much more.  The items in this collection are inspired by my love for all things minimal yet bold and meeting that fine line between the two styles. I have many more sketches to bring to fruition and look forward to sharing them with you!",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:20.811Z",
    importedBy: "entity-db-cli",
  },
};
